import { ReactComponent as DeleteIcon } from "../../Assets/Icons/TrashDeleteIcon.svg";
import { ColorScheme } from "../../Themes/ColorScheme";

export const DeleteButton = () => (
	<div
		style={{
			display: "flex",
			height: "36px",
			width: "36px",
			borderRadius: "4px",
			alignItems: "center",
			justifyContent: "center",
			cursor: "pointer"
		}}
	>
		<DeleteIcon
			width="24px"
			height="24px"
			stroke={ColorScheme.dangerPrimary}
			strokeWidth="1.5px"
		/>
	</div>
);
